import ShowHide from '../../Shared/ShowHide';

export default {
  components: {
    ShowHide
  },
  props: {
    useShowHide: {
      type: Boolean,
      default: false
    },
    urlUpdateVisibility: {
      type: String,
      default: null
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    hideText: {
      type: String,
      default: 'Hide'
    },
    showText: {
      type: String,
      default: 'Show'
    }
  }
};
